import { create } from 'zustand';

/**
 * 지도 우측 패널 선택 상태.
 * - none: 미선택 (빈 상태)
 * - farms: 농장(단일=길이 1) 또는 클러스터(길이 N) 선택 → 장비 목록 표시
 * - device: 목록에서 장비 드릴다운 → 장비 상세 표시
 */
export type MapSelection =
  | { kind: 'none' }
  | { kind: 'farms'; farmIds: string[] }
  | { kind: 'device'; deviceId: string; fromFarmIds: string[] };

interface UIState {
  // Sidebar
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;

  // Selected node in table / map
  selectedNodeId: string | null;
  setSelectedNodeId: (id: string | null) => void;

  // 지도 우측 패널 선택 (농장 클러스터/단일/장비 드릴다운 통합)
  mapSelection: MapSelection;
  setMapSelection: (s: MapSelection) => void;

  // Table filters
  nodeSearch: string;
  setNodeSearch: (q: string) => void;
  userSearch: string;
  setUserSearch: (q: string) => void;

  // Map status filter
  mapStatusFilter: string | null;
  setMapStatusFilter: (s: string | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  selectedNodeId: null,
  setSelectedNodeId: (id) => set({ selectedNodeId: id }),

  mapSelection: { kind: 'none' },
  setMapSelection: (s) => set({ mapSelection: s }),

  nodeSearch: '',
  setNodeSearch: (q) => set({ nodeSearch: q }),
  userSearch: '',
  setUserSearch: (q) => set({ userSearch: q }),

  mapStatusFilter: null,
  setMapStatusFilter: (s) => set({ mapStatusFilter: s }),
}));
